import * as React from "react";
const SvgAvatarSubtract = () => /* @__PURE__ */ React.createElement("svg", { width: 80, height: 80, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M80 0H0v80h80zM40.1 40.316q4.324.065 7.874-2.194t5.615-6.13q2.13-3.873 2.13-8.713 0-4.582-2.13-8.39-2.066-3.807-5.615-6.066Q44.424 6.5 40.1 6.5q-4.325 0-7.875 2.323-3.55 2.259-5.68 6.067-2.13 3.807-2.13 8.39 0 7.227 4.583 12.132 4.583 4.84 11.102 4.904m-23.752 14.52q-2.25 2.364-3.848 4.706C18.857 67.78 28.826 73.09 40.034 73.1h.066c11.202-.01 21.165-5.313 27.523-13.543q-1.578-2.35-3.836-4.72-3.873-4.066-9.81-6.777-5.874-2.775-13.877-2.775t-13.942 2.776q-5.937 2.71-9.81 6.776",
    clipRule: "evenodd"
  }
));
export default SvgAvatarSubtract;
